import moment from 'moment';
import dateFormats from '../SayTS/const/date-formats';

/** Bezpečně převede string/Date/null na Date (či null). */
export function toDate(value: string | Date | null | undefined): Date | null {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/** Date → "YYYY-MM-DD HH:mm:ss" (formát který BE čeká). */
export function toServerDateTime(d: Date | null | undefined): string | null {
  if (!d) return null;
  return moment(d).format(dateFormats.SERVER);
}

/** Date → "HH:mm:ss" (jen časová část). */
export function toServerTime(d: Date | null | undefined): string | null {
  if (!d) return null;
  return moment(d).format('HH:mm:ss');
}

/** Zkombinuje datum z `date` a čas z `time` do jednoho Date. */
export function combineDateAndTime(date: Date | null | undefined, time: Date | null | undefined): Date | null {
  if (!date || !time) return null;
  return new Date(
    date.getFullYear(), date.getMonth(), date.getDate(),
    time.getHours(), time.getMinutes(), 0, 0
  );
}

/** Date → Date s pouze časovou částí (datum = epoch). */
export function timeOnly(d: Date | null | undefined): Date | null {
  if (!d) return null;
  return new Date(1970, 0, 1, d.getHours(), d.getMinutes(), 0, 0);
}

/** Date → Date s pouze datovou částí (čas = 00:00). */
export function dateOnly(d: Date | null | undefined): Date | null {
  if (!d) return null;
  return new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
}

/** Parse "HH:mm" nebo "HH:mm:ss" string → Date (datum = epoch, jen čas). */
export function parseTime(timeStr: string | null | undefined): Date | null {
  if (!timeStr) return null;
  const parts = timeStr.split(':').map(Number);
  if (parts.length < 2 || isNaN(parts[0]) || isNaN(parts[1])) return null;
  return new Date(1970, 0, 1, parts[0], parts[1], parts[2] || 0, 0);
}
